module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousVendorView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Container / Vehicle Gate-Out Form")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateInType"
    }
  }, [_vm._v("Gate-Out Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "gateTypeListV",
      "option-text": "gateTypeListT",
      "list": _vm.gateTypeList,
      "placeholder": "Select Type",
      "isDisabled": _vm.gateOut.gateOutId != '' ? true : false
    },
    model: {
      value: (_vm.gateOut.gateOutType),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "gateOutType", $$v)
      },
      expression: "gateOut.gateOutType"
    }
  })], 1), _vm._v(" "), (!_vm.gateOut.gateOutType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.gateOutTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "bookOrgateOut"
    }
  }, [_vm._v("Booking / Gate-Out")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.bookOrgateOutList,
      "option-value": "bookOrgateOutValue",
      "option-text": "bookOrgateOutText",
      "placeholder": "Select Booking/Gate-Out",
      "name": "bookOrgateOut",
      "id": "bookOrgateOut"
    },
    model: {
      value: (_vm.gateOut.bookOrgateOut),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "bookOrgateOut", $$v)
      },
      expression: "gateOut.bookOrgateOut"
    }
  }), _vm._v(" "), (!_vm.gateOut.bookOrgateOut) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.bookGateOutError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.gateOut.gateOutType == 'Vehicle_With_Container' && _vm.gateOut.editContainerNo == '') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container' && _vm.gateOut.editContainerNo == '') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerNo"
    }
  }, [_vm._v("Gate-Out Container No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": new Date().toISOString().split('T')[0] != new Date(_vm.gateOut.dispatchDate).toISOString().split('T')[0] ? true : false,
      "option-value": "containerGateInId",
      "option-text": "containerNo",
      "list": _vm.containerList,
      "placeholder": "Select Container"
    },
    model: {
      value: (_vm.gateOut.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "containerNo", $$v)
      },
      expression: "gateOut.containerNo"
    }
  }), _vm._v(" "), (!_vm.gateOut.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container' && _vm.ContainerDetail.containerGateInId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container' && _vm.ContainerDetail.containerGateInId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerNo"
    }
  }, [_vm._v("Gate-Out Container No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerNo",
      "name": "containerNo",
      "disabled": ""
    },
    model: {
      value: (_vm.gateOut.editContainerNo),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "editContainerNo", $$v)
      },
      expression: "gateOut.editContainerNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [(_vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerSeal1"
    }
  }, [_vm._v("Container Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerSeal1",
      "name": "containerSeal1"
    },
    model: {
      value: (_vm.ContainerDetail.containerSeal),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerSeal", $$v)
      },
      expression: "ContainerDetail.containerSeal"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.gateOut.containerNo != '' || _vm.ContainerDetail.containerGateInId != '') ? _c('div', [_c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('label', [_c('b', [_c('u', [_vm._v("Container Details(Gate-In)")])])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Size / Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerTypeId",
      "name": "containerTypeId",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerTypeId", $$v)
      },
      expression: "ContainerDetail.containerTypeId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "grossWeight", $$v)
      },
      expression: "ContainerDetail.grossWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tare Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "tareWeight", $$v)
      },
      expression: "ContainerDetail.tareWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Mfg. Mnth-Yr")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manufractureYear",
      "name": "manufractureYear",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.manufractureYear),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "manufractureYear", $$v)
      },
      expression: "ContainerDetail.manufractureYear"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gate-In Vehicle No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleNo",
      "name": "vehicleNo",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.vehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "vehicleNo", $$v)
      },
      expression: "ContainerDetail.vehicleNo"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.gateOut.gateOutType != '' && _vm.hideGateOutV != '1' && (_vm.gateOut.bookOrgateOut == '1' || _vm.gateOut.gateOutType == 'Empty_Vehicle')) ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateOutVehicle"
    }
  }, [_vm._v("Gate-Out Vehicle No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "vehicleNo",
      "option-text": "vehicleNo",
      "list": _vm.vehicleMasterList,
      "placeholder": "Select Vehicle"
    },
    on: {
      "input": _vm.getVehicle
    },
    model: {
      value: (_vm.ContainerDetail.gateOutVehicle),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "gateOutVehicle", $$v)
      },
      expression: "ContainerDetail.gateOutVehicle"
    }
  }), _vm._v(" "), (!_vm.ContainerDetail.gateOutVehicle) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.gateOutVehicleError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.gateOut.gateOutType != '' && _vm.hideGateOutV == '1' && (_vm.gateOut.bookOrgateOut == '1' || _vm.gateOut.gateOutType == 'Empty_Vehicle')) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateOutVehicle"
    }
  }, [_vm._v("Gate-Out Vehicle No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manufractureYear",
      "name": "manufractureYear",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.gateOutVehicle),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "gateOutVehicle", $$v)
      },
      expression: "ContainerDetail.gateOutVehicle"
    }
  }), _vm._v(" "), (!_vm.ContainerDetail.gateOutVehicle) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.gateOutVehicleError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.gateOut.gateOutType != '' && (_vm.gateOut.bookOrgateOut == '1' || _vm.gateOut.gateOutType == 'Empty_Vehicle')) ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerSeal"
    }
  }, [_vm._v("Transporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "gateOutTransporter",
      "name": "gateOutTransporter"
    },
    model: {
      value: (_vm.ContainerDetail.gateOutTransporter),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "gateOutTransporter", $$v)
      },
      expression: "ContainerDetail.gateOutTransporter"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [(_vm.gateOut.gateOutType == 'Vehicle_With_Container' && _vm.gateOut.bookOrgateOut == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "GateOutContainerCondition"
    }
  }, [_vm._v("Container Condition")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "destinationddgd",
      "name": "GateOutContainerCondition"
    },
    model: {
      value: (_vm.ContainerDetail.GateOutContainerCondition),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "GateOutContainerCondition", $$v)
      },
      expression: "ContainerDetail.GateOutContainerCondition"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.ContainerDetail.GateOutContainerCondition) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerConditionError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.gateOut.gateOutType != '' && (_vm.gateOut.bookOrgateOut == '1' || _vm.gateOut.gateOutType == 'Empty_Vehicle')) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showMoreNew == true || _vm.gateOut.gateOutId == '') ? _c('div', [(_vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "destination",
      "name": "destination"
    },
    model: {
      value: (_vm.gateOut.destination),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "destination", $$v)
      },
      expression: "gateOut.destination"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "importStatus"
    }
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "ImpVal",
      "option-text": "ImpText",
      "list": _vm.ImpList,
      "placeholder": "Select Type "
    },
    model: {
      value: (_vm.gateOut.importStatus),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "importStatus", $$v)
      },
      expression: "gateOut.importStatus"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Dispatch Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "dispatchDate",
      "name": "dispatchDate",
      "disabled": ""
    },
    model: {
      value: (_vm.gateOut.dispatchDate),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "dispatchDate", $$v)
      },
      expression: "gateOut.dispatchDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Do / Booking Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "doNumber",
      "name": "doNumber"
    },
    on: {
      "keyup": _vm.sameDoNumber
    },
    model: {
      value: (_vm.gateOut.doNumber),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "doNumber", $$v)
      },
      expression: "gateOut.doNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Re-Enter Do / Booking Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "checkdoNumber",
      "name": "checkdoNumber"
    },
    on: {
      "keyup": _vm.sameDoNumber
    },
    model: {
      value: (_vm.gateOut.checkdoNumber),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "checkdoNumber", $$v)
      },
      expression: "gateOut.checkdoNumber"
    }
  }), _vm._v(" "), (_vm.gateOut.passNotMatchErr != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.passNotMatchErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Booking Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "bookingDate"
    },
    model: {
      value: (_vm.gateOut.bookingDate),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "bookingDate", $$v)
      },
      expression: "gateOut.bookingDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("DO Issue Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "doValidity"
    },
    on: {
      "input": _vm.addDays
    },
    model: {
      value: (_vm.gateOut.doValidity),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "doValidity", $$v)
      },
      expression: "gateOut.doValidity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Validity Date " + _vm._s(_vm.validateDate))]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "validityDate",
      "disabled": ""
    },
    model: {
      value: (_vm.gateOut.validityDate),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "validityDate", $$v)
      },
      expression: "gateOut.validityDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload DO / Booking Order")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadDriverDoc",
      "id": "uploadDriverDoc",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChange
    },
    model: {
      value: (_vm.gateOut.uploadDo),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "uploadDo", $$v)
      },
      expression: "gateOut.uploadDo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Images")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadImg",
      "id": "uploadImg",
      "multiple": ""
    },
    on: {
      "selected": _vm.onFileChangeImg
    },
    model: {
      value: (_vm.gateOut.uploadImg),
      callback: function($$v) {
        _vm.$set(_vm.gateOut, "uploadImg", $$v)
      },
      expression: "gateOut.uploadImg"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.gateOut.uploadImg != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.viewDocument.length > 0) ? _c('ul', _vm._l((_vm.viewDocument), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "35"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/doGateOut/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), (_vm.viewImgDocument.length > 0) ? _c('ul', _vm._l((_vm.viewImgDocument), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "35"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/doGateOutImg/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "md-flex": "15"
    }
  }, [(_vm.gateOut.gateOutType != '' && _vm.ContainerDetail.containerGateInId != '') ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    attrs: {
      "id": "addButtonLoadergate"
    },
    on: {
      "click": _vm.addContainer
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loadergate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.allContainerDetail.length > 0 && _vm.gateOut.gateOutType == 'Vehicle_With_Container') ? _c('div', {
    staticClass: "box"
  }, [_c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h5', {
    staticClass: "box-title"
  }, [_vm._v("Gate-Out Container Details ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "vehicleWith"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Status")]), _vm._v(" "), _c('th', [_vm._v("Container Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Gate-In Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Gate-Out Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Creation Date")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allContainerDetail), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bookOrgateOut == "2" ? 'Booked' : item.bookOrgateOut == "3" ? 'Validity Expired' : 'Gate-Out'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerSeal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.gateOutVehicle == '' ? '--' : item.gateOutVehicle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewModalPage(item.containerGateInId)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.allContainerDetail.length > 0 && _vm.gateOut.gateOutType == 'Empty_Vehicle') ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Vehicle Details  ")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "emptyVehicle"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Gate-Out Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Creation Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allContainerDetail), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])])
  }))])])]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "ValidityNote",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop3",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a106c8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/yard/gateOut.vue
// module id = 2704
// module chunks = 0